import { APP_DOMAIN } from "../../constants/brand";
import React, { useState, useContext } from "react";
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    Grid,
    Menu,
    MenuItem,
    useMediaQuery,
    Tooltip,
    Avatar,
    Button,
    Typography,
    Grow,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import styles from '../../Styles/ComponentStyles/SideNavigationPanel/SideNavigationPanel.module.scss';
import IconsColor from '../../Utils/IconsColor';
import { UserContext, UserContextPayload } from '../../Context/UserDetailContext';
import { useSnackbar } from "../GlobalSnackbar/GlobalSnackbar";
import calculatorIcon from "../../assets/Images/calculatorIcon.svg"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import newRBlogo from "../../assets/Images/mar-lockup-white.svg"
import newRBcollapsedLogo from "../../assets/Images/mar-mark-white.svg"
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import { getMenuItems } from "../../Utils/HelperFunctions";

interface MenuItem {
    name: string;
    icon: React.ReactNode;
    selectedIcon?: React.ReactNode;
    path: string;
    subItems?: MenuItem[];
}

export default function SideNavigationPanel(props: any) {
    const isMobile = useMediaQuery('(max-width:768px)')

    const { drawerOpen, setDrawerOpen, Logout, setFlagLoader, userDetail, setUserDetail, companyDetails } = useContext(UserContext) as UserContextPayload;
    const { showSnackbar } = useSnackbar();

    const [profileAnchorEl, setProfileAnchorEl] = useState<any>(null)
    const [quoterAnchorEl, setQuoterAnchorEl] = useState<any>(null)
    const [linkCopied, setLinkCopied] = useState(false)

    const navigate = useNavigate();

    const userRole = userDetail?.user_data?.user_role_type || '';

    const handleDrawerOpen = () => {
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
    };

    const handleMenuClick = (path: string) => {
        // setSelectedItemPath(path);
        navigate(path);
    };

    const handleProfileClick = (e: any) => {
        setProfileAnchorEl(e.currentTarget)
    }

    const handleProfileClose = () => {
        setProfileAnchorEl(null);
    };

    const handleQuoterClick = (e: any) => {
        setQuoterAnchorEl(e.currentTarget)
    }

    const handleQuoterClose = () => {
        setQuoterAnchorEl(null);
        // Reset copied state when menu closes
        setTimeout(() => setLinkCopied(false), 300);
    };

    const handleCopyLink = () => {
        const link = "https://" + window?.location?.hostname + "/rothQuoter"
        navigator.clipboard.writeText(link);
        setLinkCopied(true);
        // Auto-close after showing success state
        setTimeout(() => {
            handleQuoterClose();
        }, 1500);
    };

    const LogoutUser = async () => {
        setFlagLoader(true)
        const response = await Logout()
        if (response.status) {
            navigate('/login')
            setFlagLoader(false)
            setUserDetail({
                ...userDetail,
                flagLoggedIn: false
            });
        }
        else {
            const errorMessage = response?.error?.message || "Something Went Wrong!"
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false)
            setUserDetail({
                ...userDetail,
                flagLoggedIn: true
            });
        }
    }

    const drawer = (
        <Grid container sx={{ height: "96%" }} justifyContent={"space-between"} direction={"column"} alignItems={"center"} gap={1} flexWrap={"nowrap"} overflow={"auto"}>
            <Grid item width={drawerOpen ? "256px" : "83px"}>
                <Grid container alignItems={"start"} >
                    <Grid item xs={12} padding={"20px"}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                justifyContent: 'center'
                            }}
                        >
                            <KeyboardArrowLeftIcon
                                className={drawerOpen ? styles.closeArrowStyle : styles.openArrowStyle}
                                onClick={drawerOpen ? handleDrawerClose : handleDrawerOpen}
                                sx={{ cursor: 'pointer', color: "white", backgroundColor: "#3B78CE", borderRadius: "50%", fontSize: "24px" }}
                            />
                            <Box
                                component="img"
                                alt="Logo"
                                src={drawerOpen ? newRBlogo : newRBcollapsedLogo}
                            />
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        <List className={`${styles.navigationList}`}>
                            {getMenuItems(userRole).map((item) => (
                                <React.Fragment key={item.path}>
                                    <Grid container alignItems={"center"}>
                                        <Grid item xs={12}>
                                            <ListItem
                                                button
                                                onClick={() => handleMenuClick(item.path)}
                                                className={`${styles.listItemText}`}
                                                sx={{
                                                    padding: "0px 15px 0px 15px",
                                                    marginBottom: "10px",
                                                    borderLeft: window.location.pathname.toLowerCase().startsWith(item.path.toLowerCase()) ? "3px solid white" : "",
                                                    '&:hover': {
                                                        backgroundColor: 'transparent'
                                                    }
                                                }}
                                            >
                                                <Grid container
                                                    alignItems="center"
                                                    sx={{
                                                        backgroundColor: window.location.pathname.toLowerCase().startsWith(item.path.toLowerCase()) ? "white" : "transparent",
                                                        borderRadius: "6px",
                                                        padding: "13px",
                                                        verticalAlign: "middle"
                                                    }}
                                                >
                                                    <Grid item display={"flex"}>
                                                        <ListItemIcon className={`${styles.listItemIcon}`}>
                                                            {window.location.pathname.toLowerCase().startsWith(item.path.toLowerCase()) ? item.selectedIcon : item.icon}
                                                        </ListItemIcon>
                                                    </Grid>
                                                    {drawerOpen &&
                                                        <Grid item mt={"2px"}>
                                                            <ListItemText
                                                                sx={{
                                                                    color: window.location.pathname.toLowerCase().startsWith(item.path.toLowerCase()) ? "#04385D" : "white",
                                                                }}
                                                            >
                                                                <Grid container alignItems="center" gap={1}>
                                                                    <Grid item>
                                                                        {item.name}
                                                                    </Grid>
                                                                    {item?.name?.toLowerCase() === "training" && (
                                                                        <Grid item>
                                                                            <span
                                                                                className={styles.comingSoonSignStyle}
                                                                                style={{
                                                                                    backgroundColor: window.location.pathname.toLowerCase().startsWith(item.path.toLowerCase())
                                                                                        ? "#04385D"
                                                                                        : "#D8D8D880"
                                                                                }}
                                                                            >
                                                                                Coming Soon
                                                                            </span>
                                                                        </Grid>
                                                                    )}
                                                                </Grid>
                                                            </ListItemText>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </ListItem>
                                        </Grid>
                                    </Grid>
                                </React.Fragment>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item width={drawerOpen ? "256px" : "83px"} padding={"0 20px"}>
                <Grid container className={`${styles.bottomSection}`}>

                    <Grid item className={`${styles.userInfo}`}>
                        <Grid container gap={"23px"} flexWrap={"nowrap"} alignItems={"center"} width={"100%"} >
                            <Grid item>
                                <Grid container flexWrap={"nowrap"} alignItems={"center"} gap={"10px"}>
                                    <Grid item>
                                        <img width={24} height={22} src={calculatorIcon} alt={"icon"} />
                                    </Grid>
                                    {drawerOpen &&
                                        <>
                                            <Grid item className={styles.embedText}>
                                                Embed Roth Quoter
                                            </Grid>
                                            <Grid item >
                                                <IconButton style={{ backgroundColor: "none !important" }} onClick={handleQuoterClick}>
                                                    <IconsColor iconName="sideArrow" color="#fff" />
                                                </IconButton>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Divider
                        style={{
                            opacity: 0.8,
                            borderColor: "#D1D1D1",
                            // backgroundColor: "black",
                            height: "1px",
                            width: "100%",
                            margin: "0px 0px 20px 0px"
                        }}
                    />

                    <Grid item className={`${styles.userInfo}`}>
                        <Grid container gap={"23px"} flexWrap={"nowrap"} alignItems={"center"} width={"100%"} >
                            <Grid item>
                                <Grid container flexWrap={"nowrap"} alignItems={"center"} gap={"10px"}>
                                    <Grid item>
                                        <Avatar
                                            src={userDetail?.user_data?.user_profile_image ? userDetail?.user_data?.user_profile_image : ''}
                                            onClick={(e) => {
                                                if (drawerOpen) {
                                                    return
                                                } else {
                                                    handleProfileClick(e)
                                                }
                                            }}
                                            sx={{
                                                borderRadius: "50%",
                                                cursor: 'pointer'
                                            }}
                                        />
                                    </Grid>
                                    {drawerOpen &&
                                        <>
                                            <Grid item>
                                                <Grid container className={`${styles.userDetails}`}>
                                                    <Tooltip title={userDetail?.user_data?.user_name ? userDetail?.user_data?.user_name : 'Guest'}>
                                                        <Grid item xs={12} className={`${styles.userName}`}>
                                                            {userDetail?.user_data?.user_name ? userDetail?.user_data?.user_name : 'Guest'}
                                                        </Grid>
                                                    </Tooltip>
                                                    <Tooltip title={userDetail?.user_data?.user_role_type ? userDetail?.user_data?.user_role_type : ''}>
                                                        <Grid item xs={12} className={`${styles.userRole}`}>
                                                            {userDetail?.user_data?.user_role_type ? userDetail?.user_data?.user_role_type : ''}
                                                        </Grid>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                            <Grid item >
                                                <IconButton style={{ backgroundColor: "none !important" }} onClick={handleProfileClick}>
                                                    <IconsColor iconName="sideArrow" color="#fff" />
                                                </IconButton>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

    return (
        <>
            {
                !isMobile &&
                <Grid container className={`${styles.navigationWrapper}`}>
                    <Menu
                        anchorEl={profileAnchorEl}
                        open={profileAnchorEl}
                        onClose={handleProfileClose}
                        transformOrigin={{ horizontal: 'left', vertical: 'center' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                        sx={{
                            zIndex: "10",
                            '& .MuiGrow-root': {
                                transition: 'transform 100ms cubic-bezier(0.4, 0, 0.2, 1), opacity 100ms cubic-bezier(0.4, 0, 0.2, 1) !important',
                            }
                        }}
                        TransitionComponent={Grow}
                        transitionDuration={100}
                    >
                        <MenuItem onClick={() => { navigate("/myAccount"); handleProfileClose() }}>
                            <PersonOutlineIcon sx={{ fontSize: "18px", marginRight: "8px" }} />
                            <span className={styles.menuItemTextStyle}>My Account</span>
                        </MenuItem>
                        <Divider sx={{ borderColor: "#CECECE", height: "1px", width: "100%" }} />
                        <MenuItem sx={{ color: "#BA0000" }} onClick={() => { LogoutUser() }}>
                            <LogoutIcon sx={{ fontSize: "18px", marginRight: "8px" }} />
                            <span className={styles.menuItemTextStyle} style={{ color: "#BA0000" }}>Logout</span>
                        </MenuItem>
                    </Menu>
                    <Menu
                        anchorEl={quoterAnchorEl}
                        open={Boolean(quoterAnchorEl)}
                        onClose={handleQuoterClose}
                        transformOrigin={{ horizontal: 'left', vertical: 'center' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                        TransitionComponent={Grow}
                        transitionDuration={100}
                        sx={{
                            zIndex: "10",
                            '& .MuiPaper-root': {
                                borderRadius: '8px',
                                padding: 0,
                                minWidth: '350px',
                                maxWidth: '350px',
                            },
                            '& .MuiGrow-root': {
                                transition: 'transform 100ms cubic-bezier(0.4, 0, 0.2, 1), opacity 100ms cubic-bezier(0.4, 0, 0.2, 1) !important',
                            }
                        }}
                    >
                        <Box className={styles.rothQuoterMenu}>
                            <Typography
                                className={styles.rothQuoterTitle}
                                sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                            >
                                Add Roth Quoter to Your Site
                                <OpenInNewIcon sx={{ fontSize: "18px", cursor: "pointer" }} onClick={() => window.open(`https://dev.${APP_DOMAIN}/rothQuoter`)} />
                            </Typography>
                            <Typography className={styles.rothQuoterBody}>
                                Share this powerful Roth IRA calculator with your audience. Copy the link to embed it directly on your website using an iFrame.
                            </Typography>
                            <Button
                                className={`${styles.copyLinkButton} ${linkCopied ? styles.copiedButton : ''}`}
                                onClick={handleCopyLink}
                                fullWidth
                                disabled={linkCopied}
                                startIcon={linkCopied ? <CheckCircleIcon sx={{ fontSize: '18px' }} /> : null}
                            >
                                {linkCopied ? 'Copied!' : 'Copy Link'}
                            </Button>
                        </Box>
                    </Menu>
                    <Drawer
                        variant="permanent"
                        className={`${styles.drawer}`}
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            width: `${drawerOpen ? "256px" : "80px"}`,
                            '& .MuiDrawer-paper': {
                                background: "#04385D !important",
                                borderRight: "1px solid #D1D1D1",
                                // width: `${drawerOpen ? "256px" : "80px"}`,
                                overflowX: "Hidden",
                                overflowY: "auto"
                            }
                        }}
                        open
                    >
                        {drawer}
                    </Drawer>
                </Grid>
            }
        </>
    );
}